// src/components/ForgotPasswordForm.js
import React, { useState } from 'react';
import './AuthForms.css';

const passwordRules = [
  { label: 'Password must be at least 8 characters', test: (p) => p.length >= 8 },
  { label: 'Use a number', test: (p) => /\d/.test(p) },
  { label: 'Use a lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'Use an uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'Use a symbol', test: (p) => /[^a-zA-Z0-9]/.test(p) },
];

const ForgotPasswordForm = ({ appName, switchToLogin }) => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState('request');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const isPasswordValid = passwordRules.every(rule => rule.test(newPassword));

  const handleRequest = async () => {
    setError('');
    setLoading(true);
    try {
      const res = await fetch(process.env.REACT_APP_FORGOT_PASSWORD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setStep('reset');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    setError('');
    setLoading(true);
    try {
      const res = await fetch(process.env.REACT_APP_CONFIRM_RESET_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, newPassword })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess(true);
      setTimeout(() => switchToLogin(), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
        <h2 className="app-title">{appName}</h2>
        <h2>{step === 'request' ? 'Reset Password' : 'Enter New Password'}</h2>

        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-success">✅ Password updated! Redirecting...</div>}

        {!success && (
          <>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={step === 'reset'}
            />
            {step === 'reset' && (
              <>
                <input
                  type="text"
                  placeholder="6-digit code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
                <input
                  type="password"
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <ul className="password-checklist">
                  {passwordRules.map((rule, i) => (
                    <li key={i} className={rule.test(newPassword) ? 'valid' : ''}>
                      {rule.test(newPassword) ? '✔' : '✖'} {rule.label}
                    </li>
                  ))}
                </ul>
              </>
            )}
            <button type="button" onClick={step === 'request' ? handleRequest : handleReset} disabled={loading || (step === 'reset' && !isPasswordValid)}>
              {loading ? 'Processing...' : step === 'request' ? 'Send Code' : 'Update Password'}
            </button>
            <p className="auth-link" style={{ marginTop: '1rem' }}>
              Changed your mind? <span onClick={switchToLogin}>Go back to login</span>
            </p>
          </>
        )}
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
